export const report_trash_index = ['report_trash.index']
export const report_trash_edit = ['report_trash.edit']

export default [].concat(
    report_trash_index,
    report_trash_edit
)
